import(/* webpackMode: "eager" */ "/home/runner/work/MKFrameworkDocs/MKFrameworkDocs/app/page.tsx");
